
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'OvarianCancer_Figo',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/OvarianCancer_Figo.vue